import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useFormatDate  } from 'hooks';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import {Button, Col, OverlayTrigger, Tooltip} from 'react-bootstrap'; 
import logoAirbnb from 'assets/img/logos/airbnb_logo.png';
import logoexpedia from 'assets/img/logos/expedia.png';
import logoabritel from 'assets/img/logos/abritel.png';

const Demands = () => {

  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);


  const logo = (l) => {
    switch (l?.value) {
      case "abritel":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={logoabritel}
              alt={l}
              width={50}  
            />
      </OverlayTrigger> 
      case "airbnb":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
              src={logoAirbnb}
              alt={l}
              width={30}  
            />
      </OverlayTrigger> 
      case "expedia":
        return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {l.label}
          </Tooltip>
        }
      >
         <img
        src={logoexpedia}
        alt={l}
        width={30}  
      />
      </OverlayTrigger> 
    
      default:
        return <span>{l?.label}</span>;
    }
  }

  const loadBooking = () => {
    setL(true); 
    firebase.firestore().collection('demands')
    .orderBy('_create_At', 'desc')
    .get().then((snap)=> {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        if (l?.delete){
          // supprimer donc ne pas affiché
        }else{
          l.villa = l.property?.label || "";
          l.gh = `${l?.guest?.lastName} ${l?.guest?.firstName}`
          s.push(l)
        }
        
      })
      setData(s);
      setL(false); 
    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('demands').doc(id).update({delete:true}).then((snap)=> {
        
        toast.success("Suppression effectué");
        loadBooking();
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  };

  const del = (id) => {
    if(confirm(`Êtes vous certain de vouloir supprimer la demande?`)){
      delIt(id);
    }
  }

  const getInfoStatus = (status) => {
    let color = 'success'

    switch (status) {
      case 'canceled':
        color = 'danger';
        break;
        case 'created':
          color = 'warning'
          break;
          case 'confirmed':
            color = 'success'
            break;
    
      default:
        break;
    }
    return color;
  }


  const columns = [
    {
      accessor: 'origin',
      Header: 'Origine',
      headerProps: { className: 'text-900' }, 
      Cell: ({ row }) => (
        <div style={{display: "flex",
          alignItems: "center",
          justifyContent: "center"}}>
          {logo(row.original?.origin)} 
        </div>
      )
    }, 
    // {
    //   accessor: 'number_booking',
    //   Header: 'N°',
    //   headerProps: { className: 'text-900' }, 
    //   Cell: ({ row }) => (
    //     <p style={{textAlign:'center'}}>{row.original?.number_booking ? row.original?.number_booking : row.original?.origin_id}</p>
    
    //   )
    // },
    {
      accessor: 'gh',
      Header: 'Guest',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const {guest, adultNbr = 0, kidsNbr = 0} = rowData.row.original;
        return (
          <>
            <p style={{textAlign:'center'}}>{guest?.lastName} {guest?.firstName}<br/>
            {adultNbr} adulte{adultNbr > 1 ? 's': ''}
            {kidsNbr > 0 && (<><br/>{kidsNbr} enfant{kidsNbr > 1 ? 's': ''}</>)}
            </p>
          </>
        )
      }
    },
    {
      accessor: 'emails',
      Header: 'Email',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { emails } = rowData.row.original;
        if (emails?.length > 0){
          return(
            emails?.map((email) => { 
              return(
                <p><a class="badge badge rounded-pill badge-subtle-warning" href={`mailto:${email}`}>{email}</a></p>
              )
              })
          )
        }else{
          return(
            <p>Aucun email</p>
          )
        }
        
      }
    }, 
    {
      accessor: 'statut',
      Header: 'Status',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        return <p><a class={`badge badge rounded-pill badge-subtle-${getInfoStatus(rowData?.row?.original?.statut?.value)}`}>{rowData?.row?.original?.statut?.label}</a></p>
      }
    }, 
    {
      accessor: 'villa',
      Header: 'Villa',
      headerProps: { className: 'text-900' }, 
    }, 

    {
      accessor: 'checkin',
      Header: 'Check-in',
      headerProps: { className: 'text-900' }, 
    Cell: ({ row }) => (
      <>{row?.original?.checkin && row?.original?.checkin?.toDate !== undefined && (
         <small className="has-text-grey is-abbr-like">
            {useFormatDate(row.original?.checkin?.toDate(), {
                day:'numeric',
              weekday: 'short',
              year: 'numeric',
              month: 'short', 
            })}
          </small> 
      )}
      </>
    ),
    }, 

    {
      accessor: 'checkout',
      Header: 'Check-out',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <>{row?.original?.checkout && row?.original?.checkout?.toDate !== undefined && (
           <small className="has-text-grey is-abbr-like">
              {useFormatDate(row.original?.checkout?.toDate(), {
                day:'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short', 
              })}
            </small> 
        )}
        </>
      ),
    }, 

    // {
    //   accessor: 'booked_date',
    //   Header: 'Réserver le',
    //   headerProps: { className: 'text-900' }, 
    //   Cell: ({ row }) => (
    //     <>{row?.original?.booked_date && row?.original?.booked_date?.toDate !== undefined && (
    //        <small className="has-text-grey is-abbr-like">
    //           {useFormatDate(row.original?.booked_date?.toDate(), {
    //             day:'numeric',
    //             weekday: 'short',
    //             year: 'numeric',
    //             month: 'short', 
    //           })}
    //         </small> 
    //     )}
    //     </>
    //   ),
    // }, 

    // {
    //   accessor: 'total_pay',
    //   Header: 'Total',
    //   headerProps: { className: 'text-900' },
    //   Cell: rowData => {
    //     const { total_pay } = rowData.row.original
    //     return <span>{total_pay} €</span>
    //   }
    // },  
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id } = rowData.row.original
        return(<>
        
        <IconButton  href={`/demand/edit/${id}`}
          variant="falcon-default"
          size="sm"
          icon="edit"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1"></span>
        </IconButton> 
        
        
        <IconButton   onClick={() => {
          del(id);
        }}
          variant="falcon-danger"
          size="sm"
          icon="trash"
          transform="shrink-3"
          className='me-2' 
        >
          <span className="d-none d-sm-inline-block ms-1"></span>
        </IconButton> 
        </>
        )
      }
    }
  ];

  React.useEffect(() => {
    if (data.length === 0){
      loadBooking()
    }
  }, []);

function AdvanceTableExample() {

  if (l){
    return <p>Chargement...</p>
  }
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={205}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
      <IconButton  href="/demand/new"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouvelle demande</span>
      </IconButton> 

      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <FalconComponentCard>
      <FalconComponentCard.Header
        title="Demandes"
        light={false}
        className="border-bottom border-200" noPreview={true} 
      />
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
    );
}

export default Demands;
